import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.company.name();
  },

  shortName() {
    return this.name.substring(0, 4);
  },

  text() {
    return faker.lorem.sentence();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(division, server) {
    division.update({
      externalReferences: server.createList('external-reference', 4),
      link: server.create('link'),
      organization: server.create('organization'),
    });
  },
});
